var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_1429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 28L6.2 22.9333C4.51688 20.5441 3.76356 17.6227 4.08139 14.7175C4.39923 11.8122 5.76638 9.12285 7.92628 7.15402C10.0862 5.1852 12.8903 4.07228 15.8125 4.02413C18.7347 3.97598 21.574 4.9959 23.7976 6.89249C26.0212 8.78909 27.4762 11.432 27.8896 14.3252C28.303 17.2183 27.6463 20.1629 26.0428 22.6064C24.4393 25.0498 21.9993 26.824 19.1805 27.5961C16.3618 28.3683 13.3582 28.0852 10.7333 26.8L4 28Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.3333C12 13.5101 12.0702 13.6797 12.1953 13.8047C12.3203 13.9298 12.4899 14 12.6667 14C12.8435 14 13.013 13.9298 13.1381 13.8047C13.2631 13.6797 13.3333 13.5101 13.3333 13.3333V12C13.3333 11.8232 13.2631 11.6536 13.1381 11.5286C13.013 11.4036 12.8435 11.3333 12.6667 11.3333C12.4899 11.3333 12.3203 11.4036 12.1953 11.5286C12.0702 11.6536 12 11.8232 12 12V13.3333ZM12 13.3333C12 15.1014 12.7024 16.7971 13.9526 18.0474C15.2029 19.2976 16.8986 20 18.6667 20M18.6667 20H20C20.1768 20 20.3464 19.9298 20.4714 19.8047C20.5964 19.6797 20.6667 19.5101 20.6667 19.3333C20.6667 19.1565 20.5964 18.987 20.4714 18.8619C20.3464 18.7369 20.1768 18.6667 20 18.6667H18.6667C18.4899 18.6667 18.3203 18.7369 18.1953 18.8619C18.0702 18.987 18 19.1565 18 19.3333C18 19.5101 18.0702 19.6797 18.1953 19.8047C18.3203 19.9298 18.4899 20 18.6667 20Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_1429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.f2b99f09b52e477960f89dc27da6144f.svg";
export { ForwardRef as ReactComponent };